import Table from "components/elements/Table";
import UploadRateCard from "./UploadRateCard";
import { useEffect, useState } from "react";
import dataProvider from "core/DataProvider";
import toast from "react-hot-toast";
import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import Modal from "components/elements/Modal";

const headers = {
  id: "ID",
  period_from: "Start Date",
  period_to: "End Date",
  action: "Actions",
};

const RateCard = props => {
  const [data, setData] = useState([]);
  const [ratesData, setRatesData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getRateCards = async () => {
    setLoading(true);
    try {
      let data = await dataProvider.network.get("billing/rate-cards");

      data = data.map(item => ({
        ...item,
        action: (
          <div className="action flex flex-v-center">
            <div
              className="action-button flex flex-center"
              onClick={() => {
                showRates(item.id, item.period_from, item.period_to);
              }}
            >
              <EyeIcon />
            </div>
          </div>
        ),
      }));

      setData(data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch rate cards");
    } finally {
      setLoading(false);
    }
  };

  const showRates = async (id, periodFrom, periodTo) => {
    try {
      const data = await dataProvider.network.get(
        "billing/rate-card-rates/" + id
      );
      setRatesData({
        periodFrom,
        periodTo,
        rates: data,
      });
    } catch (error) {
      console.error(error);
      toast.error("failed to get rates");
    }
  };

  useEffect(() => {
    getRateCards();
  }, []);

  let tableData = [];
  if (ratesData) {
    console.log(ratesData.rates.length);

    for (let i = 0; i < ratesData.rates.length; i++) {
      const row = {
        spot_range: `${ratesData.rates[i][0]}-${ratesData.rates[i][1]}`,
        fixed_rate: ratesData.rates[i][2],
        additional_rate: `${ratesData.rates[i][3]} for every spot from ${ratesData.rates[i][0]} onwards`,
      };
      tableData.push(row);
    }
  }

  const modal = ratesData ? (
    <Modal
      onClose={() => {
        setRatesData(null);
      }}
    >
      <div className="flex flex-col">
        <div className="row">
          <h2>
            Rate Card ({ratesData.periodFrom} to {ratesData.periodTo})
          </h2>
        </div>
        <div className="flex mtop" style={{ minWidth: "50vw" }}>
          <Table
            headers={{
              spot_range: "Total Spots to be monitored",
              fixed_rate: "Fixed Fees (INR)",
              additional_rate: "Rate per additional spot (INR)",
            }}
            data={tableData}
            pagination={true}
          />
        </div>
      </div>
    </Modal>
  ) : (
    <></>
  );

  return (
    <div id="rate-card" className="page">
      {modal}
      <section className="rate-card-container">
        <UploadRateCard />
        <div className="box mtop">
          <div className="flex flex-v-center">
            <h3 className="pad-lr">Rate Cards</h3>
            <div className="right flex">
              <div className="el">
                {loading && (
                  <div className="loader">
                    <div className="lds-hourglass"></div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="consumption-table">
            <Table headers={headers} data={data} pagination={true} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default RateCard;
